export default "__VITE_ASSET__9zoF8pR2__"